import type { ShareDocumentApiPayload } from 'services/documents/DocumentRepository';
import type { EmailFormDefaultValues } from '../EmailForm';

export function transformEmailDataToPayload(data: EmailFormDefaultValues): ShareDocumentApiPayload {
  const allRecipients = [...(data.to ?? []), ...(data.cc ?? []), ...(data.bcc ?? [])];
  return {
    recipients: {
      raw_emails: allRecipients?.filter((signee) => signee.signeeType === undefined).map((signee) => signee.email) ?? [],
      contact_ids: data?.to?.filter((signee) => signee.signeeType === 'PERSON').map((signee) => signee.id) ?? [],
      user_ids: data?.to?.filter((signee) => signee.signeeType === 'USER').map((signee) => signee.id) ?? [],
    },
    cc_emails: data?.cc?.map((signee) => signee.email) ?? [],
    bcc_emails: data?.bcc?.map((signee) => signee.email) ?? [],
    subject: data.subject ?? '',
    body: data.body,
  };
}
